import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const ProtectedRoute = ({ children, roles, adminRoute }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={adminRoute ? '/ahupa/login' : '/login'} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={adminRoute ? '/ahupa/login' : '/'} replace />;
  }

  if (user.role === 'pending') {
    return <Navigate to="/complete-profile" replace />;
  }

  return children;
};

export default ProtectedRoute;
